import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'fa fa-tachometer',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/camp/applications',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Camp applications' },
    children: [
      {
        path: '',
        component: getView('CampApplications/ApplicationList'),
        name: 'Camp Applications List',
        meta: { label: 'Applications list' }
      },
      {
        path: ':id',
        props: true,
        component: getView('CampApplications/ApplicationForm'),
        name: 'Edit Camp Application',
        hidden: true,
        meta: { label: 'Application' }
      }
    ]
  },
  {
    path: '/pages/camps',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Camp pages' },
    children: [
      {
        path: '',
        component: getView('CampPages/CampPagesList'),
        name: 'CampPages List',
        meta: { label: 'List camp pages' }
      },
      {
        path: 'add',
        component: getView('CampPages/CampPageForm'),
        name: 'Add CampPage',
        meta: { label: 'Add camp page' }
      },
      {
        path: ':id',
        props: true,
        component: getView('CampPages/CampPageForm'),
        name: 'Edit CampPage',
        hidden: true,
        meta: { label: 'Edit camp page' }
      }
    ]
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Static pages' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'List pages' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Add page' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edit page' }
      }
    ]
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Images' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'List images' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Add image' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edit image' }
      }
    ]
  },
  // {
  //   path: '/attachments',
  //   component: Home,
  //   iconCls: 'fa fa-download',
  //   meta: { label: 'Attachments' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('Attachments/AttachmentsList'),
  //       name: 'Attachments List',
  //       meta: { label: 'List attachment' }
  //     }
  //   ]
  // },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: 'main-menu',
        props: {
          default: true,
          id: 'main-menu'
        },
        component: getView('Menus/MainMenuForm'),
        name: 'Edit Menu',
        meta: { label: 'Edit main menu' }
      },
      {
        path: 'language-menu',
        props: {
          default: true,
          id: 'language-menu'
        },
        component: getView('Menus/LanguageMenuForm'),
        name: 'Edit Language Menu',
        meta: { label: 'Edit language menu' }
      }
    ]
  },
  // {
  //   path: '/users',
  //   component: Home,
  //   iconCls: 'fa fa-group',
  //   meta: { label: 'Users' },
  //   children: [
  //     {
  //       path: '',
  //       component: getView('User/UserList'),
  //       name: 'User List',
  //       meta: { label: 'List users' }
  //     },
  //     {
  //       path: 'add',
  //       component: getView('User/UserForm'),
  //       name: 'Add User',
  //       meta: { label: 'Add user' }
  //     },
  //     {
  //       path: ':id',
  //       props: true,
  //       component: getView('User/UserForm'),
  //       name: 'Edit User',
  //       hidden: true,
  //       meta: { label: 'Edit user' }
  //     }
  //   ]
  // },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Settings' },
    children: [
      // {
      //   path: 'site',
      //   component: getView('Settings/SettingsForm'),
      //   name: 'Settings Form',
      //   meta: { label: 'Site settings' }
      // },
      {
        path: 'page',
        component: getView('Settings/PageSettingsForm'),
        name: 'Page Settings Form',
        meta: { label: 'Site settings' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Admin panel`
    : 'Admin panel'
  next()
})

export default router
